import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface InvitationDetails {
  invitationId: string;
  token: string;
  status: 'PENDING' | 'ACCEPTED' | 'CANCELLED';
  appId: string;
  appName: string;
  appDescription?: string; // optional — not always present in API response
  appImage: string;
  businessId: string;
  businessName: string;
  invitedAt: string;
  acceptedAt: string | null;
  canAccept: boolean;
}

@Component({
  selector: 'app-app-invite',
  templateUrl: './app-invite.component.html',
  styleUrls: ['./app-invite.component.scss']
})
export class AppInviteComponent implements OnInit {
  token: string = '';
  invitation: InvitationDetails | null = null;
  pageLoader = true;
  notFound = false;
  errorMessage = '';
  accepting = false;
  accepted = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') || '';
    if (this.token) {
      this.fetchInvitation();
    } else {
      this.notFound = true;
      this.pageLoader = false;
    }
  }

  fetchInvitation(): void {
    this.http
      .get<InvitationDetails>(
        `${environment.baseUrl}app/app/invitation/token/${this.token}`
      )
      .subscribe({
        next: (res:any) => {
          debugger;
          this.invitation = res.data;
          this.pageLoader = false;
        },
        error: (err) => {
          this.pageLoader = false;
          this.notFound = true;
          const status = err?.error?.status ?? err?.status;
          if (status === 404) {
            this.errorMessage = 'Invitation not found.';
          } else if (status === 410) {
            this.errorMessage = 'This invitation has been cancelled.';
          } else {
            this.errorMessage = 'Something went wrong. Please try again.';
          }
        }
      });
  }

  acceptInvitation(): void {
    if (!this.invitation?.canAccept || this.accepting) return;
    this.accepting = true;
    this.errorMessage = '';

    this.http
      .post(`${environment.baseUrl}app/app/invitation/accept/${this.token}`, {})
      .subscribe({
        next: () => {
          this.accepting = false;
          this.accepted = true;
          if (this.invitation) {
            this.invitation.status = 'ACCEPTED';
          }
        },
        error: (err) => {
          this.accepting = false;
          const msg: string = err?.error?.message ?? '';
          if (msg.toLowerCase().includes('already')) {
            this.errorMessage = 'This invitation has already been accepted.';
          } else if (msg.toLowerCase().includes('cancel')) {
            this.errorMessage = 'This invitation has been cancelled.';
          } else {
            this.errorMessage = 'Something went wrong. Please try again.';
          }
        }
      });
  }

  goToDashboard(): void {
    const businessId = localStorage.getItem('businessId');
    const staffId = localStorage.getItem('staffId');
    if (businessId && staffId) {
      this.router.navigate(['/admin/home'], {
        queryParams: { businessId, staffId }
      });
    } else {
      this.router.navigate(['/']);
    }
  }

  goToApps(): void {
    const businessId = localStorage.getItem('businessId');
    const staffId = localStorage.getItem('staffId');
    if (businessId && staffId) {
      this.router.navigate(['/admin/app-registry/list-apps'], {
        queryParams: { businessId, staffId }
      });
    } else {
      this.router.navigate(['/']);
    }
  }
}